export const ADMIN_ROLES = {
  ADMIN: 1,
  OWNER: 2
}

export const ONBOARDING_ADMIN_ROLE = 2
